import { InjectionToken } from '@angular/core';

export interface AppConfig {
  auth: {
    userPoolId: string;
    userPoolClientId: string;
    domain: string;
  };
  api: {
    url: string;
  };
}

let configuration: AppConfig | null = null;
export const setConfiguration = (appConfig: AppConfig | null) => {
  configuration = appConfig;
};
export const getConfiguration = (): AppConfig => {
  if (!configuration) {
    throw new Error('App configuration is not defined');
  }
  return configuration;
};

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
